// Based on: https://hubble.corp.stripe.com/saved-queries/a00c2d55-89f8-4fce-9dac-a284e537bc53?sort=-totalComponents&t=results
// You can use the query above to identify expected render load errors and add them to the expectedErrors array
const expectedErrors: RegExp[] = [/Loading\schunk\s\d*\sfailed/];

export const shouldReportRenderError = (errorMessage: string) => {
  if (
    expectedErrors.some((expectedError) => expectedError.test(errorMessage)) ||
    errorMessage === ''
  ) {
    return false;
  }

  return true;
};
